import {CommonModule} from '@angular/common';
import {Component, computed, inject, input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {IconName} from '@cov/ui-angular';
import {TranslocoPipe} from '@jsverse/transloco';
import {map} from 'rxjs';
import {SoldToShipToService} from '../../services/sold-to-ship-to.service';
import {mapToViewAddress} from '../../utils/address.utils';

@Component({
  selector: 'cov-sold-to-information-menu',
  imports: [CommonModule, ReactiveFormsModule, TranslocoPipe],
  templateUrl: './sold-to-information-menu.component.html',
  styleUrl: './sold-to-information-menu.component.scss',
})
export class SoldToInformationMenuComponent {
  protected readonly IconName = IconName;

  // INJECTS
  public soldToService = inject(SoldToShipToService);

  // STATE
  public isOpen = input<boolean>(false);

  public addresses$ = this.soldToService.allAddresses$?.pipe(
    map((addresses) => {
      return addresses ? addresses.map(mapToViewAddress.bind(this)) : [];
    }),
  );

  public count = computed(() => {
    return this.soldToService.allAddresses()?.length ?? 0;
  });

  protected readonly MAX_VISIBLE_ADDRESSES_WITHOUT_SCROLLING = 7;
}
